import React from 'react';
import './Tender.css';
import Header from '../component/Header/Header';
import Navbar from '../component/NavBar/Navbar';
import Footer from '../component/Footer/Footer';

const tenders = [
  {
    id: 1,
    title: 'INVITATION TO TENDER AND EXPRESSION OF INTEREST (EoI) FOR GOODS, WORKS AND SERVICE UNDER 2025 CAPITAL APPROPRIATION',
    description: `The Hospital wishes to invite experienced, competent and reputable contractors, suppliers, and service providers to submit bid documents and Expressions of Interest (EoI) for the implementation of the following projects under the 2025 capital budget appropriation.`,
    status: 'Ongoing',
    deadline: '14th April & 12th May, 2025',
    link: '/downloads/Tender.pdf',
    
  },
 
];

// Utility to check if all deadlines have passed
const isDeadlinePassed = (deadlineStr) => {
  const today = new Date();

  // Handle cases like "14th April & 12th May, 2025"
  const dateParts = deadlineStr
    .split('&')
    .map(d => d.trim())
    .filter(d => /\d{1,2}(st|nd|rd|th)? [A-Za-z]+,? \d{4}/.test(d));

  for (let dateStr of dateParts) {
    const cleanDate = dateStr.replace(/(st|nd|rd|th)/g, '');
    const parsedDate = new Date(cleanDate);
    if (parsedDate >= today) return false; // Still valid
  }

  return dateParts.length > 0; // All dates passed
};

const Tender = () => {
  return (
    <>
      <Header />
      <Navbar />
      <div className="tenders-wrapper">
        <h2 className="heading">Official Tenders & EoI – FNPHD Kano</h2>
        <div className="tender-list">
          {tenders.map((tender) => {
            const isClosed = isDeadlinePassed(tender.deadline);
            return (
              <div key={tender.id} className="tender-card">
                <h3 className="tender-title">{tender.title}</h3>
                <p className="tender-description">{tender.description}</p>
                <div className="tender-footer">
                  <div>
                    <p className="tender-deadline"><strong>Status:</strong> {isClosed ? 'Closed' : tender.status}</p>
                    <p className="tender-deadline"><strong>Deadline:</strong> {tender.deadline}</p>
                  </div>
                  <a href={tender.link} className="view-button" target="_blank" rel="noopener noreferrer">
                    View Tender
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Tender;
